import { Icon } from 'src/components';

import styles from './ModalClose.module.scss';


type TProps = {
	onClick: () => void;
};

export function ModalClose(props: TProps) {
	const { onClick } = props;

	return (
		<div
			onClick={ onClick }
			className={ styles.modalClose }
		>
			<Icon icon="icon-cancel"></Icon>
		</div>
	);
}
